import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlComponent } from '../base-control.component';

@Component({
  selector: 'boi-textarea-input',
  templateUrl: './textarea-input.component.html',
  styleUrls: ['./textarea-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TextareaInputComponent,
      multi: true
    }
  ]
})
export class TextareaInputComponent extends BaseControlComponent {
  @Input() public placeholder = '';
  @Input() public rows = 6;
  @Input() public maxLength?: number;
  @Input() public isReadonly: boolean;
  @Input() public pattern: string;
  @Input() public isTooltipLast = true;
}
